/*! ATOMGYM patches — bfcache + cross-tab cart + :has() fallback (vanilla, defer) */
(function(){
  "use strict";

  // ─── 1. bfcache restore : reset body lock + cart count + drawer state ──────
  // Évite que body reste position:fixed après navigation back-forward avec drawer ouvert
  window.addEventListener("pageshow", function(e){
    if (e.persisted){
      try {
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.left = "";
        document.body.style.right = "";
        document.body.style.width = "";
        document.body.style.overflow = "";
        document.body.style.overscrollBehavior = "";
      } catch(_) {}
      // Re-sync cart count + ferme tous overlays restés ouverts
      try {
        document.querySelectorAll(".cart-drawer.is-open,.search-overlay.is-open,.account-modal.is-open,.nav-menu.is-open").forEach(function(el){
          el.classList.remove("is-open");
        });
      } catch(_) {}
      try {
        var raw = localStorage.getItem("atomgym_cart_v1");
        var items = raw ? JSON.parse(raw) : [];
        var count = items.reduce(function(s,i){ return s + (i.qty||1); }, 0);
        document.querySelectorAll(".cart-count").forEach(function(b){
          b.textContent = count;
          b.style.display = count > 0 ? "" : "none";
        });
      } catch(_) {}
    }
  });

  // ─── 2. Cross-tab cart sync via BroadcastChannel + storage event ──────────
  // Résout la race condition multi-tabs (last-write-wins) en re-rendant à chaque update
  function refreshCartUI(){
    try {
      var raw = localStorage.getItem("atomgym_cart_v1");
      var items = raw ? JSON.parse(raw) : [];
      var count = items.reduce(function(s,i){ return s + (i.qty||1); }, 0);
      document.querySelectorAll(".cart-count").forEach(function(b){
        b.textContent = count;
        b.style.display = count > 0 ? "" : "none";
      });
      // Si drawer ouvert, déclenche un re-render via custom event que app.js écoute
      if (document.querySelector(".cart-drawer.is-open")){
        document.dispatchEvent(new CustomEvent("atomgym:cart-changed"));
      }
    } catch(_) {}
  }
  // storage event = autre onglet a écrit
  window.addEventListener("storage", function(e){
    if (e.key === "atomgym_cart_v1") refreshCartUI();
  });
  // BroadcastChannel = même origine, instantané
  if ("BroadcastChannel" in window){
    try {
      var bc = new BroadcastChannel("atomgym-cart");
      bc.onmessage = refreshCartUI;
      // Wrapper setItem pour broadcast quand le cart change dans CET onglet
      var origSetItem = Storage.prototype.setItem;
      Storage.prototype.setItem = function(k, v){
        var r = origSetItem.call(this, k, v);
        if (k === "atomgym_cart_v1"){ try { bc.postMessage("update"); } catch(_) {} }
        return r;
      };
    } catch(_) {}
  }

  // ─── 3. :has() fallback : toggle .is-checked class sur shipping/payment radios ─
  // Firefox <121, iOS Safari <15.4, Samsung Internet <19 ne supportent pas :has()
  // On miroir la sélection radio avec une classe sur le parent .shipping-option/.payment-option/.pay-method
  function syncCheckedState(){
    document.querySelectorAll('input[name="shipping"],input[name="payment"],input[name="pay-method"]').forEach(function(i){
      var parent = i.closest(".shipping-option,.payment-option,.pay-method");
      if (parent) parent.classList.toggle("is-checked", i.checked);
    });
  }
  document.addEventListener("change", function(e){
    if (e.target && (e.target.name === "shipping" || e.target.name === "payment" || e.target.name === "pay-method")){
      var name = e.target.name;
      document.querySelectorAll('input[name="'+name+'"]').forEach(function(x){
        var p = x.closest(".shipping-option,.payment-option,.pay-method");
        if (p) p.classList.toggle("is-checked", x.checked);
      });
    }
  });
  // Sync initial state au load (radios déjà checked au chargement)
  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", syncCheckedState);
  } else {
    syncCheckedState();
  }

  // ─── 4. Post-checkout cleanup : si Shopify cart vide mais localStorage plein → vider localStorage ──
  // Détection : utilisateur revient après checkout success (Shopify a clear le cart serveur)
  // ou panier expiré côté Shopify. On aligne notre UI custom sur la source de vérité Shopify.
  function syncLocalFromShopify(){
    var raw;
    try { raw = localStorage.getItem("atomgym_cart_v1"); } catch(_){ return; }
    if (!raw) return;
    var items;
    try { items = JSON.parse(raw); } catch(_){ return; }
    if (!Array.isArray(items) || items.length === 0) return;
    // Notre localStorage a des items. On compare avec Shopify cart.
    fetch("/cart.js", { credentials: "same-origin", headers: { "Accept":"application/json" } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(cart){
        if (!cart) return;
        if (cart.item_count === 0) {
          // Shopify cart vide → user a probablement complété un checkout. On vide notre UI.
          try { localStorage.removeItem("atomgym_cart_v1"); } catch(_){}
          refreshCartUI();
        }
      })
      .catch(function(){});
  }
  // Run après load, mais pas sur les pages cart/checkout pour éviter false positives
  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", syncLocalFromShopify);
  } else {
    syncLocalFromShopify();
  }

})();
